import axios from "axios";
import * as actionTypes from "./ActionTypes";

export const getCallHistory =
    (search = "", page = 1) =>
        async (dispatch) => {
            const authToken = localStorage.getItem("authToken");
            dispatch({ type: actionTypes.GET_CALL_HISTORY_INIT });
            try {
                const config = {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                };

                const res = await axios.get(
                    `https://app.loungebridge.com/api/admin/scheduled-calls-history?status=completed&search=${search}&page=${page}`,
                    config
                );

                dispatch({
                    type: actionTypes.GET_CALL_HISTORY_SUCCESS,
                    payload: res.data,
                });

                return res.data;
            } catch (error) {
                dispatch({
                    type: actionTypes.GET_CALL_HISTORY_FAIL,
                    payload:
                        error.response && error.response.data.message
                            ? error.response.data.message
                            : error.message,
                });
                return false;
            }
        };

// call details
export const getcallDetails = (scheduleId) => async (dispatch) => {
    const payload = {
        scheduleId,
    };
    const authToken = localStorage.getItem("authToken");

    dispatch({ type: actionTypes.PAYMENT_DETAILS_INIT });
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };

        const res = await axios.post(
            `https://app.loungebridge.com/api/admin/payment-detail`,
            payload,
            config
        );
        dispatch({
            type: actionTypes.PAYMENT_DETAILS_SUCCESS,
            payload: res.data,
        });
        return res.data;
    } catch (error) {
        dispatch({
            type: actionTypes.PAYMENT_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        return false;
    }
};